<template>
  <label class="container_check">
    {{ value }}
    <input type="checkbox" />
    <span class="checkmark"></span>
  </label>
</template>
<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>
